import { Button, type ButtonProps, Typography } from "@mui/material";
import { Link } from "Navigation/Link";

interface Props extends ButtonProps {
  link: string;
  text: string;
  replace?: boolean;
  resetHistory?: boolean;
}

export const ButtonLink = ({
  link,
  text,
  color,
  replace,
  resetHistory,
  ...rest
}: Props) => (
  <Button
    fullWidth
    component={Link}
    to={link}
    replace={replace}
    resetHistory={resetHistory}
    color={color}
    {...rest}
    sx={{
      "&.Mui-disabled": {
        color: ({ palette }) =>
          color === "primary" ? palette.common.white : palette.info.light,
        background: ({ palette }) =>
          color === "info" ? "none" : palette.action.disabledBackground,
      },
      height: (theme) => theme.spacing(13),
      fontWeight: 600,
      ...rest.sx,
    }}
  >
    <Typography fontSize={14} fontWeight="inherit">
      {text}
    </Typography>
  </Button>
);
